export { ScreenReaderInfo } from './StyledComponents';
